import { isMobile } from "@rio-cloud/rio-uikit/utils/deviceUtils";

interface ITypeButtonGroupProps {
    viewType: "card" | "list";
    setViewType: (viewType: "card" | "list") => void;
    exportButton?: React.ReactNode;
    copyTokenButton?: React.ReactNode;
}

const TypeButtonGroup = (props: ITypeButtonGroupProps) => {
    const { viewType, setViewType, exportButton, copyTokenButton } = props;
    return (
        <div className={`flex items-center ${isMobile() ? "w-full" : ""}`}>
            <div className={`table-toolbar-column table-toolbar-column-spacer ${isMobile() ? "w-full" : ""}`}>
                <div className={`btn-toolbar ${isMobile() ? "w-full" : ""}`}>
                    <div className={`TableViewToggles btn-group display-flex flex-row ${isMobile() ? "ml-auto mb-4" : "mt-2"}`}>
                        <button 
                            className={`btn btn-default btn-color-primary btn-icon-only ${viewType === 'card' ? "active" : ""}`} 
                            type="button"
                            onClick={() => setViewType("card")}
                        >
                            <span className="rioglyph rioglyph-cards-table">
                            </span>
                        </button>
                        <button 
                            className={`btn btn-default btn-color-primary btn-icon-only ${viewType === 'list' ? "active" : ""}`} 
                            type="button"
                            onClick={() => setViewType("list")}
                        >
                            <span 
                                className="rioglyph rioglyph-th-list">
                            </span>
                        </button>
                        {copyTokenButton}
                        {exportButton}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TypeButtonGroup;